import { render, staticRenderFns } from "./WardMessageContacts.vue?vue&type=template&id=2272538a&scoped=true&"
import script from "./WardMessageContacts.vue?vue&type=script&lang=js&"
export * from "./WardMessageContacts.vue?vue&type=script&lang=js&"
import style0 from "./WardMessageContacts.vue?vue&type=style&index=0&id=2272538a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2272538a",
  null
  
)

export default component.exports